import React from 'react';

import { Button, ButtonColor, ButtonWithColorProps } from './button';

export const DefaultButton: React.FunctionComponent<ButtonWithColorProps> = ({
  children,
  ...props
}) => (
  <Button color={ButtonColor.DEFAULT} {...props}>
    {children}
  </Button>
);
